import React, { useContext } from "react";
import { PurchasesContextProvider } from "../Context/PurchasesContext";
import { Button } from "@chakra-ui/react";
import PurchasesFilter from "./PurchasesFilter";
import PurchasesTable from "./PurchasesTable";
import ContentCard from "../Common/Layout/ContentCard";
import { useHistory } from "react-router-dom";
import Body from "../Common/Body";
import { UsersContext } from "../Context/UsersContext";
import { userIsAllowed } from "../../Utils/userIsAllowed";

const Purchases = () => {
  const history = useHistory();
  const { currentUser } = useContext(UsersContext);

  return (
    <PurchasesContextProvider>
      <Body title={"Lista de compras"}>
        <ContentCard>
          <PurchasesFilter />
        </ContentCard>
        <ContentCard>
          {userIsAllowed(currentUser, [13]) && (
            <Button
              my="2"
              colorScheme="blue"
              onClick={() => history.push("/compras/nueva")}
            >
              + Compra
            </Button>
          )}
          <PurchasesTable></PurchasesTable>
        </ContentCard>
      </Body>
    </PurchasesContextProvider>
  );
};

export default Purchases;
